import { collectDeviceContext, createBrowserAnalyticsEmitter, liveContext } from "@verity/analytics/browser";
import type {
	AnalyticsContext,
	ClientEventDefinition,
	EventDefinitionInput,
} from "@yujacorp/verity-api-contract/schemas/zod";
import apiClient from "./api-client";

const APP = { name: "verity", platform: "web_app" } as const;

let device: Promise<AnalyticsContext> | undefined;
const deviceContext = () => (device ??= collectDeviceContext());

const emitter = createBrowserAnalyticsEmitter(
	(events, { signal }) =>
		apiClient.trpc.trpc.analytics.ingestClientEventBatch.mutate(
			{ auth: { method: "jwt" }, events: [...events] },
			{ signal },
		),
	{
		preEmitHook: async (event) => ({
			...event,
			context: { ...(await deviceContext()), ...liveContext(APP), ...event.context },
		}),
	},
);

export const emitAnalytics = <Definition extends ClientEventDefinition>(
	definition: Definition,
	input: EventDefinitionInput<Definition>,
): void => emitter.emit(definition, input);

export const instituteSubject = (instituteUuid: string) =>
	({ type: "institute", format: "access_control_uuid", instituteUuid }) as const;
